import { useEffect, useState } from 'react'
import Modal from '../../../../common/components/molecule/Modal/Modal'
import TextInput from '../../../../common/components/atom/TextInput/TextInput'
import ButtonV2 from '../../../../common/components/atom/ButtonV2/Button'
import { useCreateMomi } from '../../../../features/momi/hooks/useMomis'
import { useToast } from '../../../../common/providers/ToastProvider/useToast'

interface AddMomiDialogProps {
  open: boolean
  onClose: () => void
}

export default function AddMomiDialog({ open, onClose }: AddMomiDialogProps) {
  const [uuid, setUuid] = useState('')
  const [name, setName] = useState('')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const createMomi = useCreateMomi()
  const toast = useToast()

  useEffect(() => {
    if (open) {
      setUuid('')
      setName('')
      setErrorMessage(null)
    }
  }, [open])

  const handleSubmit = () => {
    const trimmedUuid = uuid.trim()
    const momi_name = name.trim() === '' ? 'MoMi-' + trimmedUuid.slice(0, 8) : name.trim()
    setErrorMessage(null)

    createMomi.mutate({
      momi: {
        momi_uuid: trimmedUuid,
        momi_name,
      },
      callbackFunc: ({ error }) => {
        if (error) {
          const status = error?.response?.status
          const backendMsg = error?.response?.data?.message
          const msg =
            backendMsg ??
            (status === 409 || status === 400
              ? 'UUID déjà enregistré ou invalide'
              : "Erreur lors de l'ajout du MoMi")
          setErrorMessage(msg)
          toast.error(msg)
        } else {
          toast.success('MoMi ajouté')
          onClose()
        }
      },
    })
  }

  return (
    <Modal isOpen={open} handleClose={onClose}>
      <h2>Ajouter un MoMi</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
        <TextInput
          label="UUID"
          value={uuid}
          onChange={(e) => {
            setUuid(e.target.value)
            if (errorMessage) setErrorMessage(null)
          }}
        />
        <TextInput
          label="Nom (optionnel)"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        {errorMessage && (
          <div
            role="alert"
            style={{
              background: '#fdecea',
              border: '1px solid #f5c2c0',
              color: '#b00020',
              padding: '0.5rem 0.75rem',
              borderRadius: 4,
              fontSize: 13,
            }}
          >
            {errorMessage}
          </div>
        )}
      </div>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
        <ButtonV2
          onClick={onClose}
          variant="outlined"
          color="secondary"
          size="medium"
        >
          Annuler
        </ButtonV2>
        <ButtonV2
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          size="medium"
          disabled={uuid.trim() === ''}
        >
          Enregistrer
        </ButtonV2>
      </div>
    </Modal>
  )
}
